interface PanKnobProps {
  value: number; // -1 to 1
  onChange: (value: number) => void;
}

export function PanKnob({ value, onChange }: PanKnobProps) {
  const label = value === 0 ? 'C' : value < 0 ? `L${Math.round(Math.abs(value) * 100)}` : `R${Math.round(value * 100)}`;

  return (
    <input
      type="range"
      min={-1}
      max={1}
      step={0.01}
      value={value}
      onChange={(e) => onChange(Number(e.target.value))}
      className="w-12 h-1 accent-[#07E5B0] cursor-pointer"
      title={`Pan: ${label}`}
    />
  );
}
